import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as userService from "../../services/userService";
import { handleApiError } from "../storeEffects";
import { UserAction, userFailure, userSuccess } from "./storeUser";

export type UserThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, UserAction>

export const getUserPage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return userService.getUsersPage()
        .then(
            usersPage => {
                dispatch(userSuccess(usersPage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(userFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};
